export default "<div [id]=\"ktDatatableOptions.IdName\" [busyIf]=\"primengTableHelper.isLoading\"></div>"